(() => {
  if (!document.body.classList.contains('cedilako')) return;
  let queued = false;
  function applyBrand() {
    queued = false;
    document.querySelectorAll('.es-popup-button, .es-sticky-btn, .es-cta-btn').forEach(button => {
      if (button.style.backgroundColor !== 'rgb(24, 76, 67)' || button.style.getPropertyPriority('background-color') !== 'important') {
        button.style.setProperty('background', '#184C43', 'important');
        button.style.setProperty('border-color', '#184C43', 'important');
      }
      if (button.style.borderRadius !== '14px') button.style.setProperty('border-radius', '14px', 'important');
      if (button.style.boxShadow !== 'none') button.style.setProperty('box-shadow', 'none', 'important');
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(applyBrand); }
  }
  applyBrand();
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['style']});
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();
